import {STORAGE_IOS_WIDGET_KEY as storageKey} from 'shared/const';
import {storageProxy} from 'interactors';

interface IosDeviceDependencies {
  storage?: StorageService;
}

export function updateWidget(data: DeviceWidgetData, di: IosDeviceDependencies = {}): void {
  const {storage = storageProxy} = di;
  storage.setItem(storageKey, Object.values(data));
}
